import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Image, View, Text, StyleSheet } from 'react-native';

class PantryPhoto extends Component {
  static propTypes = {
    url: PropTypes.string,
  };

  render() {
    const { url } = this.props;
    let src = url || 'https://s3.amazonaws.com/nyc-fac-dev/images/plentiful_bag.png';
    if (url && url.substring(0, 4) !== 'http') {
      src = 'https://s3.amazonaws.com/nyc-fac-dev/images/' + url;
    }
    return (
      <View style={styles.pantryImageContainer}>
        <Image source={{ uri: src }} style={styles.pantryImage} />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  pantryImageContainer: {
    width: 64,
    height: 64,
  },
  pantryImage: {
    width: 64,
    height: 64,
  },
});

export default PantryPhoto;
